import React from 'react';
import PropTypes from 'prop-types';

function Redo({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        d="M7.859 19.656S3.96 15.788 6.59 11.008c1.735-3.154 6.473-3.106 6.473-3.106l4.546.98"
      />
      <path strokeLinecap="round" d="M14.7 4.202l2.911 4.696-4.63 2.94" />
    </svg>
  );
}

Redo.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Redo;
